import React, { useEffect, useState, useRef } from "react";
import { mapList } from "../../services/mapService";
import { useNavigate } from "react-router-dom";
import { getEmergencyLogs } from "../../services/userApiServicer";

export default function Map() {
  const [selectedUser, setSelectedUser] = useState(null);
  const [markerInstance, setMarkerInstance] = useState([]);
  const [mapData, setMapData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]); // 검색 결과 목록
  const navigate = useNavigate();
  const mapRef = useRef(null);

  // 지도 로드
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("토큰 없음. 로그인 필요");
      return;
    }

    // 카카오맵 스크립트 중복 방지
    const existingScript = document.getElementById("kakao-map-sdk");
    if (existingScript) {
      initMap();
      return;
    }

    const script = document.createElement("script");
    script.id = "kakao-map-sdk";
    script.src =
      "//dapi.kakao.com/v2/maps/sdk.js?appkey=7be12d091023480ed21909b830c26e67&autoload=false";
    script.async = true;
    script.onload = initMap;
    document.head.appendChild(script);

    async function initMap() {
      window.kakao.maps.load(async () => {
        try {
          // 지도 초기 설정
          const container = document.getElementById("map");
          const options = {
            center: new window.kakao.maps.LatLng(35.2813, 127.2903),
            level: 8,
          };
          const map = new window.kakao.maps.Map(container, options);
          mapRef.current = map;

          const defaultMarkerImage = new window.kakao.maps.MarkerImage(
            "/media/map_dot.png",
            new window.kakao.maps.Size(25, 25)
          );
          const activeMarkerImage = new window.kakao.maps.MarkerImage(
            "/media/map_dot_a.png",
            new window.kakao.maps.Size(25, 25)
          );

          // 사용자 데이터 불러오기
          const data = await mapList(token);
          console.log("📍 mapList 응답:", data);
          const users = data?.user_list || [];
          setMapData(users);

          const markers = [];

          users.forEach((user) => {
            if (user.lat && user.lng) {
              const position = new window.kakao.maps.LatLng(user.lat, user.lng);
              const marker = new window.kakao.maps.Marker({
                position,
                image: defaultMarkerImage,
              });
              marker.setMap(map);
              markers.push(marker);

              // 마커 클릭 이벤트
              window.kakao.maps.event.addListener(marker, "click", async () => {
                markers.forEach((m) => m.setImage(defaultMarkerImage));
                marker.setImage(activeMarkerImage);
                map.panTo(position);

                const userLogs = await loadEmergencyLogs(user.id, token);
                setSelectedUser({
                  id: user.id,
                  name: user.name,
                  age: user.age,
                  address: user.full_address,
                  illness: user.pec,
                  numberEmer: user.alert_count,
                  recods: userLogs,
                });
              });
            }
          });

          setMarkerInstance(markers);
        } catch (err) {
          console.error("지도 초기화 실패:", err);
        }
      });
    }

    return () => {
      const existing = document.getElementById("kakao-map-sdk");
      if (existing) existing.remove();
    };
  }, []);

  // 응급상황 로그 불러오기 함수
  const loadEmergencyLogs = async (userId, token) => {
    try {
      const logs = await getEmergencyLogs(userId, token);
      if (Array.isArray(logs) && logs.length > 0) {
        return logs.map((log) => {
          let formattedDate = "날짜 없음";
          try {
            formattedDate = new Date(
              log.create_date.replace(" ", "T")
            ).toLocaleDateString();
          } catch {}
          return { title: formattedDate, content: log.content || "내용 없음" };
        });
      }
    } catch (e) {
      console.error("응급상황 기록 불러오기 실패:", e);
    }
    return [];
  };

  // 검색 입력 시
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchText(value);

    if (value.trim()) {
      const lower = value.toLowerCase();
      const results = mapData.filter((user) => {
        const name = user.name?.toLowerCase() || "";
        const addr = user.full_address?.toLowerCase() || "";
        return name.includes(lower) || addr.includes(lower);
      });
      console.log("🔍 검색 결과:", results);
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  };

  // select에서 사용자 선택 시
    const handleSelectUser = async (userId) => {
    if (!userId) return;
    const foundUser = mapData.find((u) => String(u.id) === userId);
    if (!foundUser || !mapRef.current) return;

    const defaultMarkerImage = new window.kakao.maps.MarkerImage(
        "/media/map_dot.png",
        new window.kakao.maps.Size(25, 25)
    );
    const activeMarkerImage = new window.kakao.maps.MarkerImage(
        "/media/map_dot_a.png",
        new window.kakao.maps.Size(25, 25)
    );

    markerInstance.forEach((marker, idx) => {
  const user = mapData[idx];
  if (!user) return;
  marker.setImage(defaultMarkerImage);
  if (user.id === foundUser.id) {
    marker.setImage(activeMarkerImage);
    const position = new window.kakao.maps.LatLng(user.lat, user.lng);
    mapRef.current.panTo(position);
    setTimeout(() => mapRef.current.setCenter(position), 500);
  }
});
    const logs = await loadEmergencyLogs(
        foundUser.id,
        localStorage.getItem("token")
    );

    setSelectedUser({
        id: foundUser.id,
        name: foundUser.name,
        age: foundUser.age,
        address: foundUser.full_address,
        illness: foundUser.pec,
        numberEmer: foundUser.alert_count,
        recods: logs,
    });

    setSearchResults([]);
    setSearchText(foundUser.name);
    };


  // 닫기 버튼 클릭
  const handleClose = () => {
    if (markerInstance.length > 0) {
      const defaultMarkerImage = new window.kakao.maps.MarkerImage(
        "/media/map_dot.png",
        new window.kakao.maps.Size(25, 25)
      );
      markerInstance.forEach((marker) => marker.setImage(defaultMarkerImage));
    }
    setSelectedUser(null);
  };

    // 자세히보기
    const handleDetailClick = () => {
    if (selectedUser?.id) {
        navigate(`/user/${selectedUser.id}`, { 
        state: { 
            report_id: selectedUser.report_id, // 필요하면
            defaultTab: "alert" 
        } 
        });
    }
    };


  return (
    <div className="mapwrp">
        {/* 🔍 검색창 */}
        <div className="map-search">
        <input
            type="text"
            placeholder="이름 또는 주소로 검색"
            value={searchText}
            onChange={handleSearchChange}
        />

        {searchResults.length > 0 && (
            <select
            onChange={(e) => handleSelectUser(e.target.value)}
            defaultValue=""
            className="mapselect"
            >
            <option value="">검색 결과 선택</option>
            {searchResults.map((user) => (
                <option key={user.id} value={user.id}>
                {user.name} ({user.full_address})
                </option>
            ))}
            </select>
        )}
        </div>


      {/* 지도 */}
      <div id="map"></div>

   {/* 사용자 정보 패널 */}
      {selectedUser && (
        <div className="map_user">
          <h3>사용자 정보</h3>
          <p className="adress">{selectedUser.address}</p>
          <ul>
            <li>
              <span>이름</span>
              {selectedUser.name}
            </li>
            <li>
              <span>나이</span>
              {selectedUser.age} 세
            </li>
            <li>
              <span>지병</span>
              {selectedUser.illness}
            </li>
            <li>
              <span>응급상황 횟수</span>
              {selectedUser.numberEmer} 회
            </li>
          </ul>

          <p className="map_recod_tit">응급상황 기록</p>
          <div className="recodwrap">
            {selectedUser.recods && selectedUser.recods.length > 0 ? (
              selectedUser.recods.map((record, idx) => (
                <dl key={idx}>
                  <dt className="recodtit">{record.title} 발생한 응급상황</dt>
                  <dd className="recodbox">{record.content}</dd>
                </dl>
              ))
            ) : (
              <p>기록된 응급상황이 없습니다.</p>
            )}
          </div>

          <div className="btn-group">
            <button className="btncolor01" onClick={handleDetailClick}>
              자세히 보기
            </button>
            <button className="btncolor02" onClick={handleClose}>
              닫기
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

